export default "__VITE_ASSET__b89212cb__"